export function defineColumnsNumber(universesLength: number) {
  switch (universesLength) {
    case 9:
      return 3
    case 10:
      return 5
    case 13:
    case 14:
      return 5
    case 15:
    case 16:
    case 17:
      return 6
    default:
      return 4
  }
}

export function defineRowsNumber(universesLength: number) {
  if (universesLength === 10) {
    return 2
  }
  else if (universesLength < 9) {
    return 2
  }
  else {
    return 3
  }
}
